/**
 * Alert Settings Registry
 *
 * Centralizes alert type settings so adding a new alert type only requires
 * adding one registry entry here (+ the detector implementation).
 *
 * Each entry defines:
 * - The settings key in AlertsSettings
 * - The alert type enum value
 * - The Zod schema for validation
 * - Default settings values
 * - Mapping from settings → AlertThresholdConfig upsert fields
 */
import { z } from "zod";
// ===== Per-alert-type settings schemas =====
// Define these here (not in companySettings.ts) to avoid circular imports,
// since companySettings.ts imports the registry.
/**
 * Settings for CHECKLIST_OVERDUE alert type
 */
export const ChecklistOverdueAlertSettingsSchema = z.object({
    enabled: z.boolean(),
    warningDaysOverdue: z.number().int().nonnegative(),
    criticalDaysOverdue: z.number().int().positive(),
    checkIntervalSeconds: z.number().int().positive(),
});
function createEntry(entry) {
    return entry;
}
export const ALERT_SETTINGS_REGISTRY = [
    createEntry({
        settingsKey: "checklistOverdue",
        alertType: "CHECKLIST_OVERDUE",
        schema: ChecklistOverdueAlertSettingsSchema,
        defaults: {
            enabled: true,
            warningDaysOverdue: 1,
            criticalDaysOverdue: 4,
            checkIntervalSeconds: 3600,
        },
        toThresholdConfig: (s) => ({
            enabled: s.enabled,
            thresholds: {
                warningDaysOverdue: s.warningDaysOverdue,
                criticalDaysOverdue: s.criticalDaysOverdue,
            },
            checkInterval: s.checkIntervalSeconds,
        }),
    }),
    // Adding a new alert type = add one entry here
];
